import React from 'react';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Image, { IImage } from 'tbk-components/src/components/Image';
import Carousel from 'tbk-components/src/components/Carousel';
import CarouselItem from 'tbk-components/src/components/CarouselItem';

export interface ITextCarousel {
	text: string;
}

export interface IImageCarousel {
	image?: IImage;
}

export interface ICarouselHeroBannerProps extends IBaseElementProps {
	subheading?: string;
	imageCarousel?: IImageCarousel[];
	imageCarouselDuration?: string;
	textCarousel?: ITextCarousel[];
	textCarouselDuration?: string;
}

/**
 * Carousel Hero Banner
 * @block
 * @requiresHooks
 * @icon format-image
 */

const CarouselHeroBanner: React.FC<ICarouselHeroBannerProps> = ({
	subheading,
	imageCarousel,
	textCarousel,
	textCarouselDuration
}) => {

	const randomImage = imageCarousel[Math.floor(Math.random()*imageCarousel.length)];

	return (
		<div className="carousel-hero-banner">
			<div className="carousel-hero-banner__image">
				{imageCarousel && (
					<Image {...randomImage.image} />
				)}
			</div>
			<div className="carousel-hero-banner__text">
				<div className="carousel-hero-banner__text-container">
					{textCarousel && (
						<div className="carousel-hero-banner__text-carousel">
							<Carousel
								showArrows={false}
								showBullets={false}
								options={{
									type: 'carousel',
									autoplay: textCarouselDuration,
									animationDuration: 0,
									wipeThreshold: false,
									dragThreshold: false,
									hoverpause: false,
								}}
							>
								{(textCarousel || []).map(({ text }, index) => (
									<CarouselItem key={index}>
										<div className="carousel-hero-banner__heading">{text}</div>
									</CarouselItem>
								))}
							</Carousel>
						</div>
					)}
					{subheading && (
						<h2 className="carousel-hero-banner__subheading">{subheading}</h2>
					)}
				</div>
			</div>
		</div>
	);
};

export default CarouselHeroBanner;
